
import BaseScene from '@Scenes/BaseScene';

import * as Scenes from '@Config/scenes';
import KeyCodes from '@Config/keycodes';

import Game from '@Game';

class KeyboardControlsScene extends BaseScene
{
    constructor()
    {
        super(Scenes.KEYBOARD_CONTROLS);
    }

    public create()
    {
        this.input.keyboard.on('keydown', this.onKeyDown.bind(this));
        this.input.keyboard.on('keyup', this.onKeyUp.bind(this));

        const gameSize = this.getGameSize();
    }


    private onKeyDown(event:KeyboardEvent)
    {
        Game.freerider.setKeyDown(event.keyCode);
    }

    private onKeyUp(event:KeyboardEvent)
    {
        if(KeyCodes.ACCELERATE.indexOf(event.keyCode) === -1)
        {
            Game.freerider.setKeyUp(event.keyCode);
        }
    }
}

export default KeyboardControlsScene;